import styled from "styled-components";

const Wrapper
	= styled.div`
		height: ${(props) => props.height};
		width: ${(props) => props.width};
	`

export default Wrapper
